import { render, staticRenderFns } from "./TheSourceLoader.vue?vue&type=template&id=f0799fcc&scoped=true&"
import script from "./TheSourceLoader.vue?vue&type=script&lang=js&"
export * from "./TheSourceLoader.vue?vue&type=script&lang=js&"
import style0 from "./TheSourceLoader.vue?vue&type=style&index=0&id=f0799fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0799fcc",
  null
  
)

export default component.exports